<template>
  <div class="announce-bar__container">
    <time-zone-warning-bar :is-desktop="isDesktop"/>
    <free-center-bar v-if="noticeBarStatus.isDisplayFreeCenterBar" :is-desktop="isDesktop"/>
    <pre-payment-bar v-if="noticeBarStatus.isDisplayPrePaymentBar" :is-desktop="isDesktop"/>
    <demo-center-bar v-if="noticeBarStatus.isDisplayDemoCenterBar" :is-desktop="isDesktop"/>
	<demo-center-link-bar v-if="isDisplayDemoCenterLinkBar" :is-desktop="isDesktop"/>
  </div>
</template>

<script>
import { computedGetters } from "../../../utils/vuex-helper";
import FreeCenterBar from "./FreeCenterBar";
import PrePaymentBar from "./PrePaymentBar";
import DemoCenterBar from "./DemoCenterBar";
import DemoCenterLinkBar from "./DemoCenterLinkBar"
import TimeZoneWarningBar from "./TimeZoneWarningBar";

export default {
  name: "TopAnnounceBar",
  components: {TimeZoneWarningBar, PrePaymentBar, DemoCenterBar, FreeCenterBar, DemoCenterLinkBar},
  props: {
		isDesktop: {
			type: Boolean,
			default: true,
		},
	},
	computed: {
		...computedGetters(["noticeBarStatus"]),
		isDisplayDemoCenterLinkBar(){
			return this.$router.currentRoute.path === "/register"
		}
	},
};
</script>

<style lang="scss">
</style>
